/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス契約値情報
 */
export interface Szoa301aRequestGasConvalInfo { 
    /**
     * 契約最大使用量
     */
    aykSdiSyory?: number;
    /**
     * 年間使用量
     */
    aykNknSyory?: number;
    /**
     * 年間引取量
     */
    aykNknHikry?: number;
    /**
     * 契約昼間使用量
     */
    aykNknHirry?: number;
    /**
     * 契約夜間使用量
     */
    aykNknYakry?: number;
    /**
     * 契約月別使用量１月
     */
    kykTbts01ry?: number;
    /**
     * 契約月別使用量２月
     */
    kykTbts02ry?: number;
    /**
     * 契約月別使用量３月
     */
    kykTbts03ry?: number;
    /**
     * 契約月別使用量４月
     */
    kykTbts04ry?: number;
    /**
     * 契約月別使用量５月
     */
    kykTbts05ry?: number;
    /**
     * 契約月別使用量６月
     */
    kykTbts06ry?: number;
    /**
     * 契約月別使用量７月
     */
    kykTbts07ry?: number;
    /**
     * 契約月別使用量８月
     */
    kykTbts08ry?: number;
    /**
     * 契約月別使用量９月
     */
    kykTbts09ry?: number;
    /**
     * 契約月別使用量１０月
     */
    kykTbts10ry?: number;
    /**
     * 契約月別使用量１１月
     */
    kykTbts11ry?: number;
    /**
     * 契約月別使用量１２月
     */
    kykTbts12ry?: number;
    /**
     * 負荷率(％)
     */
    kykFukPc?: number;
}

